import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "useCurrentColor", "style"];
import React from 'react';
import { ContextLayout } from '../../context-provider';
export default function IconSquareDisabled(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$useCurrentColo = props.useCurrentColor,
      useCurrentColor = _props$useCurrentColo === void 0 ? true : _props$useCurrentColo,
      style = props.style,
      other = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("svg", _extends({
      className: prefixCls + "-icon " + prefixCls + "-icon-square-disabled " + className,
      width: "1em",
      height: "1em",
      style: style,
      viewBox: "0 0 20 20",
      fill: useCurrentColor ? 'currentColor' : '#F7F8FA'
    }, other), /*#__PURE__*/React.createElement("path", {
      stroke: "#E5E6EB",
      d: "M15.6 2.5H4.4c-1 0-1.9.8-1.9 1.9v11.2c0 1 .8 1.9 1.9 1.9h11.2c1 0 1.9-.8 1.9-1.9V4.4c0-1.1-.8-1.9-1.9-1.9z"
    }));
  });
}